// extracted by mini-css-extract-plugin
export default {"registred":"RegisteredBadge_registred__9I4dW","green":"RegisteredBadge_green__3U-tw","white":"RegisteredBadge_white__1j1e5"};